//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      data: 3,
      text:'3分 一般',
      reply:''
    }
  },
  watch: {
    data(val) {
      switch (val) {
        case 1:
          this.text = '1分 非常不满意'
          break
        case 2:
          this.text = '2分 不满意'
          break
        case 3:
          this.text = '3分 一般'
          break
        case 4:
          this.text = '4分 满意'
          break
        case 5:
          this.text = '5分 非常满意'
          break
      }
    },
  },
  methods: {
    async Pingjia() {
      let data = 'cmd=gd_pingjia'+
        '&gd_pingjia=' + this.data +
        '&pingjia_yijian=' + this.reply +
        '&id_root=' + this.$route.params.id
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/gd.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/workorder/'+ _this.$route.params.id)
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/workorassess.vue